export default "__VITE_ASSET__DTLNZ_cR__"